import { Stack } from '@chakra-ui/react';
import CalendlyModal from '@components/atoms/CalendlyModal';
import { DEFAULT_AGENT_SLUG } from '@utils/getCalendlySlugForUser';
import { useState } from 'react';
import Avatars from './Avatars';
import Carousel from './Carousel';
import Featured from './Featured';

export enum VideoState {
  NOT_STARTED,
  PLAYING,
  PAUSED,
}

const AgentPicker = ({ agents, utmParams }) => {
  const [calendlyModalIsOpen, setCalendlyModelIsOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [playingIndex, setPlayingIndex] = useState(null);

  const selectedAgent = agents[selectedIndex];

  if (!selectedAgent) return null;

  return (
    <Stack w="100%" maxW={800} spacing={4} alignItems="center">
      <CalendlyModal
        isOpen={calendlyModalIsOpen}
        utmParams={utmParams}
        setIsOpen={setCalendlyModelIsOpen}
        eventSlug={`${selectedAgent.agentProfile.scheduling_system_slug}/${DEFAULT_AGENT_SLUG}`}
      />
      {/* Mobile */}
      <Carousel
        display={{ base: 'flex', md: 'none' }}
        playingIndex={playingIndex}
        setPlayingIndex={setPlayingIndex}
        onButtonClick={(index) => {
          setSelectedIndex(index);
          setCalendlyModelIsOpen(true);
        }}
        agents={agents}
      />
      {/* Desktop */}
      <Avatars
        display={{ base: 'none', md: 'flex' }}
        agents={agents}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
      />
      <Featured
        index={selectedIndex}
        utmParams={utmParams}
        display={{ base: 'none', md: 'flex' }}
        playingIndex={playingIndex}
        setPlayingIndex={setPlayingIndex}
        agent={selectedAgent}
        onButtonClick={() => setCalendlyModelIsOpen(true)}
      />
    </Stack>
  );
};

export default AgentPicker;
